export default Object.freeze({
  Text: 1,
  TextMultiple: 2,
  Int32: 3,
  Int: 3,
  Decimal: 4,
  Boolean: 5,
  DateTime: 6,
  Date: 7,
  Time: 8,
  Choice: 9,
  DataBaseRemoteSearch: 10,
  DataBaseRemoteList: 11,
  WebServiceRemoteSearch: 12,
  WebServiceRemoteList: 13,
  SelectorUser: 14,
  SelectorPosition: 15,
  SelectorUserGroup: 16,
  Table: 17,
  Attachment: 18,
  AutoCalculatedByTableColumn: 19,
  FieldDynamicEntityList: 20,
  CalculatedByFormula: 21,
  Image: 22,
  Photo: 23,
  Signature: 24,
  GoToAction: 25,
  Slider: 26,
  FieldDynamicEntitySearch: 27,
  SelectorArea: 28,
  RadioGroup: 29,
  CheckGroup: 30,
  Url: 31,
  Email: 32,
  Location: 33,
  Password: 34,
  LikertScale: 35,
  // ... Automy Internal Entity
  InternalEntity: 0,
});
